import { LoggingService } from './logging-service'
import { Logger } from './logger'

export const loggingService: Logger = new LoggingService()
